import { createSelector } from 'reselect'
import { convertData2JsonForm } from '../../../../shared/lib/convertData2JsonForm'

export const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)
const selectClaim = state => state.claim

const selectClaimForm = createSelector(selectClaim, ({ form }) => form)

export const selectClaimStages = createSelector(selectClaim, ({ stages }) => stages)

export const getClaimFormLoading = createSelector(selectClaim, ({ isLoading }) => isLoading)

export const getClaimFormError = createSelector(selectClaimForm, ({ error }) => error)

export const getClaimFormAlert = createSelector(selectClaimForm, ({ alert }) => alert)

export const getClaimFormData = createSelector(selectClaimForm, ({ data }) => data)

export const getClaimTemplates = createSelector(selectClaimForm, ({ templates }) => templates ?? [])

export const getClaimStageCurrent = createSelector(
  selectClaimForm,
  ({ data }) => data?.stages?.current,
)

export const getVisibleFormData = createSelector(
  [getClaimFormData, getClaimTemplates],
  (formData, templates) => {
    if (!formData) return
    const { resultObject, resultSchema } = convertData2JsonForm(formData)
    if (
      'compensation_responsible_id' in resultObject &&
      resultObject?.['compensation_responsible_id']
    ) {
      resultObject['compensation_responsible_id'] = Number(
        resultObject['compensation_responsible_id'],
      )
    }
    if (
      'reclamation_responsible_id' in resultObject &&
      resultObject?.['reclamation_responsible_id']
    ) {
      resultObject['reclamation_responsible_id'] = String(
        resultObject['reclamation_responsible_id'],
      )
    }
    if ('compensation_office_id' in resultObject && resultObject?.['compensation_office_id']) {
      resultObject['compensation_office_id'] = String(resultObject['compensation_office_id'])
    }
    if ('work_executor_id' in resultObject && resultObject?.['work_executor_id']) {
      resultObject['work_executor_id'] = Number(resultObject['work_executor_id'])
    }
    return {
      resultSchema,
      resultObject,
      templates,
    }
  },
)
